import flare from '@/plugins/flare';

/**
 * Setup Vue warning handler to track warnings in Flare
 * Captures all Vue warnings including prop validation errors
 *
 * @param {App} app - Vue application instance
 */
export function setupVueWarningHandler(app) {
    app.config.warnHandler = (msg, instance, trace) => {
        // Prepare warning context
        const context = {
            message: msg,
            url: typeof window !== 'undefined' ? window.location?.href : 'SSR',
            path: typeof window !== 'undefined' ? window.location?.pathname : 'SSR',
            componentTrace: trace,
            timestamp: new Date().toISOString(),
            userAgent: typeof navigator !== 'undefined' ? navigator?.userAgent : 'SSR',
        };

        // Add component name if available
        if (instance) {
            const componentName =
                instance.$options?.name || instance.$options?.__name || instance.type?.name || instance.type?.__name || 'AnonymousComponent';
            context.component = componentName;
        }

        // Add route information if using Inertia/Vue Router
        if (instance?.$page) {
            context.route = {
                component: instance.$page.component,
                url: instance.$page.url,
                props: instance.$page.props,
            };
        }

        // Log to console in development for debugging
        if (import.meta.env.DEV) {
            console.warn('[Vue Warning Handler]', context);
        }

        // Report to Flare
        try {
            flare.report({
                message: `Vue Warning: ${msg}`,
                severity: 'warning',
                category: 'vue-warning',
                context: context,
            });
        } catch (error) {
            // Fail silently to avoid breaking the app
            console.error('[Flare Vue Warning Handler] Failed to report warning:', error);
        }

        // Still show the warning in console for development
        if (import.meta.env.DEV) {
            console.warn(msg);
            if (trace) {
                console.warn(trace);
            }
        }
    };
}
